// extracted by mini-css-extract-plugin
export default {"container":"poweredBy_container__quIQl"};